import { Link } from "react-router-dom";
import { BRAND } from "@/constants/brand";

interface UnifiedFooterProps {
  variant?: "sirppi" | "career-path";
}

export const UnifiedFooter = ({ variant = "sirppi" }: UnifiedFooterProps) => {
  const isSirppi = variant === "sirppi";

  return (
    <footer className="bg-surface border-t border-border py-8">
      <div className="container-apple text-center">
        {/* Taglines - Only for Sirppi variant */}
        {isSirppi && (
          <>
            <p className="text-sm text-muted-foreground mb-1">
              {BRAND.taglines.main}
            </p>
            <p className="text-sm text-muted-foreground mb-6">
              {BRAND.taglines.secondary}
            </p>
          </>
        )}

        {/* Career Path variant - Link back to ecosystem */}
        {!isSirppi && (
          <p className="text-sm text-muted-foreground mb-6">
            Part of the{" "}
            <Link 
              to="/" 
              className="text-primary hover:underline font-medium"
            >
              Sirppi ecosystem
            </Link>
          </p>
        )}

        {/* Links */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-6">
          <Link 
            to="/about" 
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            About
          </Link>
          <Link 
            to="/products" 
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Products
          </Link>
          <Link 
            to="/pricing" 
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Pricing
          </Link>
          <Link 
            to="/contact" 
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Contact
          </Link>
          <Link 
            to="/terms" 
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Terms
          </Link>
          <Link 
            to="/privacy" 
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Privacy
          </Link>
          <Link 
            to="/refund" 
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Refund
          </Link>
          <Link 
            to="/cancellation" 
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Cancellation
          </Link>
        </div>

        {/* Copyright */}
        <p className="text-sm text-muted-foreground">
          {BRAND.copyrightStatic}
        </p>
      </div>
    </footer>
  );
};
